import { Component, Input } from '@angular/core';

/**
 * Generated class for the MajimeParticipantComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'majime-participant',
  templateUrl: 'majime-participant.html'
})
export class MajimeParticipantComponent {

  @Input() config: object;

  constructor() {
    console.log('Hello MajimeParticipantComponent Component');
  }

  ionViewDidLoad(){
    console.log("Config is ", JSON.stringify(this.config));
  }

}



// WEBPACK FOOTER //
// ./src/components/majime-participant/majime-participant.ts